import { FreebieWidgetRenderingDetails } from "@swiggy-private/cart-types";
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { VALID_RENDERING_DETAILS_TYPE } from "@swiggy-private/cart-ui";
import { isEmpty } from "@swiggy-private/js-utils";

/**
 * Extracts freebie widget data from cart response rendering details
 */
export const getFreebieWidgetData = (cartResponse: ReviewedCart | null): FreebieWidgetRenderingDetails | null => {
    if (isEmpty(cartResponse?.data?.rendering_details)) {
        return null;
    }

    const freebieWidget = cartResponse?.data?.rendering_details?.find(
        (item) => item.type.toLowerCase() === VALID_RENDERING_DETAILS_TYPE.SNACC_FREEBIE_WIDGET.toLowerCase(),
    );

    return (freebieWidget as FreebieWidgetRenderingDetails) || null;
};

/**
 * Checks if freebie widget should be displayed
 */
export const shouldShowFreebieWidget = (cartResponse: ReviewedCart | null): boolean => {
    const freebieWidget = getFreebieWidgetData(cartResponse);

    if (isEmpty(freebieWidget)) {
        return false;
    }

    const { meta } = freebieWidget;
    return !isEmpty(meta?.items) && meta?.items?.length > 0;
};
